import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";

import "./vueEditor";

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

axios.defaults.baseURL = "/api";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
